
import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import Button from "@material-ui/core/Button";
import comprovanteSolicitacaoActions from "../store/comprovanteSolicitacao.actions";
import comprovanteSolicitacaoSelector from "../store/comprovanteSolicitacao.selectors";
import autoBind from "react-autobind";
import { makeStyles } from '@material-ui/core/styles';
import Card from "@common/externos/components/card/card.externo";
import Typography from "@material-ui/core/Typography";


class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const { routerManager } = this.props;
    const { id } = routerManager.params;
    this.props.comprovanteSolicitacaoActions.getComprovanteSolicitacao(id);
  }

  onPrint() {
    const { routerManager, comprovanteSolicitacaoActions } = this.props;
    const { id } = routerManager.params;
    comprovanteSolicitacaoActions.getImprimirComprovante(id);
  }

  useStyles = makeStyles(theme => ({
    button: {
      margin: theme.spacing(1),
    },
  }));

  render() {
    const { comprovanteSolicitacaoSelector, routerManager } = this.props;
    const { comprovanteSolicitacao } = comprovanteSolicitacaoSelector;
    const { id } = routerManager.params;
    return (
      <Fragment>
        <Typography>
          <Card>
            <h2 className={'mb-4'}>Solicitação enviada com sucesso <span><i className={"far fa-check-circle text-primary ml-2"}></i></span></h2>

            <div dangerouslySetInnerHTML={{ __html: comprovanteSolicitacao.descricao }} />

            <div style={{ borderLeft: "5px solid #E0E0E0", paddingLeft: 12, background: '#FAFAFA' }} className={'mb-4 mt-4 py-2'}>
              Caso alguma informação esteja incorreta, <span onClick={() => routerManager.redirect({ name: "deca.retificarsolicitacao", parameters: { id } })} className={'btn btn-link px-1'} style={{ paddingBottom: '8px', fontSize: '1rem' }}>clique aqui</span> para retificar sua solicitação.
            </div>

            <Button variant="contained" color="primary" className="justify-center" onClick={() => this.onPrint()}>
              Imprimir Solicitação Completa
              <i className="fas fa-print ml-3"></i>
            </Button>
          </Card>
        </Typography>
      </Fragment>);
  }
}

export default connect({
  actions: {
    comprovanteSolicitacaoActions
  },
  selectors: {
    comprovanteSolicitacaoSelector
  }
})(Container);
